(function () {
  'use strict';

  function initPriceForms() {
    var forms = document.querySelectorAll('[data-sm-collection-price-form]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      if (form._smPriceFormBound) return;
      form._smPriceFormBound = true;

      form.addEventListener('submit', function () {
        var minInput = form.querySelector('[data-sm-price-min]');
        var maxInput = form.querySelector('[data-sm-price-max]');

        [minInput, maxInput].forEach(function (input) {
          if (!input || input.value === '') return;

          var cents = Math.round(parseFloat(input.value) * 100);
          if (isNaN(cents)) {
            input.removeAttribute('name');
            return;
          }

          input.value = cents;
        });
      });
    });
  }

  function initSortBy() {
    document.querySelectorAll('[data-sm-collection-sort]').forEach(function (select) {
      if (select._smSortBound) return;
      select._smSortBound = true;

      var currentSort = select.getAttribute('data-current-sort') || select.value;
      if (currentSort) select.value = currentSort;

      select.addEventListener('change', function () {
        var queryParams = {};

        if (location.search.length) {
          location.search
            .substring(1)
            .split('&')
            .forEach(function (pair) {
              var parts = pair.split('=');
              if (parts.length > 1) {
                queryParams[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
              }
            });
        }

        queryParams.sort_by = select.value;

        var query = Object.keys(queryParams)
          .map(function (key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(queryParams[key]);
          })
          .join('&');

        location.search = query;
      });
    });
  }

  function initMobileFilters() {
    document.querySelectorAll('[data-sm-collection-filters]').forEach(function (wrap) {
      if (wrap.dataset.smFiltersInit) return;
      wrap.dataset.smFiltersInit = 'true';

      var toggle = wrap.querySelector('[data-sm-filters-toggle]');
      var panel = wrap.querySelector('[data-sm-filters-panel]');
      var backdrop = wrap.querySelector('[data-sm-filters-backdrop]');
      var closeButtons = wrap.querySelectorAll('[data-sm-filters-close]');

      if (!toggle || !panel) return;

      function openFilters() {
        wrap.classList.add('is-open');
        document.body.classList.add('is-sm-filters-open');
        toggle.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        if (backdrop) backdrop.hidden = false;
      }

      function closeFilters() {
        wrap.classList.remove('is-open');
        document.body.classList.remove('is-sm-filters-open');
        toggle.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        if (backdrop) backdrop.hidden = true;
      }

      toggle.addEventListener('click', openFilters);

      closeButtons.forEach(function (button) {
        button.addEventListener('click', closeFilters);
      });

      if (backdrop) {
        backdrop.addEventListener('click', closeFilters);
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && wrap.classList.contains('is-open')) {
          closeFilters();
        }
      });
    });
  }

  function init() {
    initPriceForms();
    initSortBy();
    initMobileFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
